import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { ShopAnalyticsService } from 'src/app/data/repository/analytics-repository/shop-analytics.service';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';
import { ShopService } from 'src/app/data/repository/shop-repository/shop.service';
import { TextHelper } from 'src/app/utils/text-helper';
import { ShopShared } from '../../general/shared/shop-shared';

@Component({
  selector: 'app-shop-discount-bottomsheet',
  templateUrl: './shop-discount-bottomsheet.component.html',
  styleUrls: ['./shop-discount-bottomsheet.component.scss'],
})
export class ShopDiscountBottomsheetComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  code: string;
  invalidCode: boolean = false;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {},
    private bottomSheetRef: MatBottomSheetRef<ShopDiscountBottomsheetComponent>,
    private shopService: ShopService,
    private shopShared: ShopShared,
    private shopAnalytics: ShopAnalyticsService,
    private CookingStoryGroceryService: CookingStoryGroceryService,
    private texthelper: TextHelper
  ) {}

  ngOnInit(): void {}
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }
  change() {
    console.log('changed');

    this.invalidCode = false;
  }
  goBack() {
    this.bottomSheetRef.dismiss();
  }
  submit() {
    if (!this.code || this.code.length === 0) {
    } else {
      this.code = this.texthelper.replacePersian(this.code);
      this.shopService
        .getPrices(this.code)
        .then((res) => {
          this.invalidCode = false;
          if (res.isSuccess()) {
            if (res.getData().getReward()) {
              this.shopShared.reward = res.getData().getReward();
              this.shopShared.hasReward();
            } else {
              this.shopAnalytics.analyticShopDiscountApplied();
              this.shopShared.setDiscountValues(
                res.getData().getPlanPrices(),
                this.code
              );
              this.shopShared.hasDiscount(true);
            }
            setTimeout(() => {
              this.bottomSheetRef.dismiss();
            }, 100);
            this.CookingStoryGroceryService.openPopUp.next(
              'کد تخفیف اعمال شد '
            );
          } else {
            // this.CookingStoryGroceryService.openPopUp.next(
            //   'کد تخفیف اشتباه است  '
            // );
            this.invalidCode = true;
          }
        })
        .catch((res: Error) => {
          // this.CookingStoryGroceryService.openPopUp.next(
          //   'کد تخفیف اشتباه است  '
          // );
          console.log(res);

          this.invalidCode = true;
        });
    }
  }
}
